// extracted by mini-css-extract-plugin
module.exports =  {"input":"aH3CVH","dark":"TJOj5N","error":"oIeNCD","errorText":"jewzc0"};